"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const map_1 = __importDefault(require("./map"));
const expandable_card_container_1 = __importDefault(require("../ExpandableCardContainer/expandable-card-container"));
const styles_1 = require("./styles");
const messages_1 = __importDefault(require("../../lib/messages"));
const location_1 = __importDefault(require("./location"));
const with_error_boundary_1 = require("../ErrorFallback/with-error-boundary");
const ProviderLocations = ({ locations, mlocations, getLocationUrl, locationCallback, googleMapsUrl, track, config, awsMapConfig }) => {
    return (react_1.default.createElement(expandable_card_container_1.default, { id: "profile-locations-section", track: track },
        react_1.default.createElement(styles_1.LocationsSectionHeader, null,
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.providerLocationsHeader))),
        react_1.default.createElement(map_1.default, { locations: locations, config: config, googleMapsUrl: googleMapsUrl, awsMapConfig: awsMapConfig }),
        react_1.default.createElement(styles_1.LocationsList, null, locations.map((loc) => (react_1.default.createElement(location_1.default, { key: loc.external_id, location: loc, getLocationUrl: getLocationUrl, locationCallback: locationCallback, mloc: mlocations[loc.primary_marketable_location_id], config: config }))))));
};
exports.default = (0, with_error_boundary_1.withErrorBoundary)(ProviderLocations);
//# sourceMappingURL=provider-locations.js.map